import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { formatSSN } from "../utils/dataConverter";
import CustomButton from "./CustomButton";

interface SSNReviewPromptProps {
    show: boolean;
    forSpouse: boolean;
    ssn: string;
    onAccept: () => void;
    onCancel: () => void;
}

const SSNReviewPrompt = ({ 
    show,
    forSpouse,
    ssn,
    onAccept,
    onCancel
}: SSNReviewPromptProps) => {
    return (<Dialog
    role="dialog"
    aria-modal="true"
    open={show}
    onClose={onCancel}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    disablePortal={true}
  >
    <DialogTitle id="alert-dialog-title">
      {"Double check your " + (forSpouse ? "spouse's SSN" : "SSN")}
    </DialogTitle>
    <DialogContent>
      <DialogContentText id="alert-dialog-description">
          We want to be sure you've entered the correct SSN.
      </DialogContentText>
        <div style={{ display: 'flex', justifyContent: 'center'}}>
          <h1 style={{ color: '#5D7E01'}}>{formatSSN(ssn)}</h1>
        </div>
        <DialogContentText id="alert-dialog-description">
            Click Accept to continue or Cancel to re-enter your {forSpouse ? "spouse's SSN" : "SSN"}.
        </DialogContentText>
    </DialogContent>
    <DialogActions className='modal-button-container bottom-padding'>
      <CustomButton
          onClick={onCancel}
          label="Cancel"
          buttonSize="btn-sm"
      />
      <CustomButton
          type={"submit"}
          variant="contained"
          label="Accept"
          buttonSize="btn-sm"
          onClick={onAccept}
    />
    </DialogActions>
  </Dialog>
  );
};

export default SSNReviewPrompt;
